import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import * as AlertingActions from '@core-app/state/alerting/alerting.actions';
import { MonitorType } from '@enums';
import { FormGroup } from '@angular/forms';
import { Monitor } from '@interfaces';
import { Store } from '@ngrx/store';

@Component({
  selector: 'fip-non-confirming-parts-leaving-supplier-modal',
  templateUrl: './non-confirming-parts-leaving-supplier-modal.component.html',
  styleUrl: './non-confirming-parts-leaving-supplier-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NonConfirmingPartsLeavingSupplierModalComponent {
  private readonly _store = inject(Store);

  /**
   * Handles form submission when user creates a monitor.
   *
   * Receives the form group from the form component and dispatches an action
   * to upsert the monitor with the configured settings.
   */
  onFormSubmit(formGroup: FormGroup): void {
    const formValue = formGroup.value;

    const monitor: Monitor = {
      partitionKey: 'v1',
      monitorType: MonitorType.NonConfirmingPartsLeavingSupplier,
      name: formValue.name,
      initialQueryDate: formValue.initialQueryDate.toISOString(),
      recipientGroupId: formValue.recipientsGroupId,
      priorityLevel: 'P2',
    };

    this._store.dispatch(AlertingActions.upsertMonitor({ monitor }));
  }
}
